// extracted by mini-css-extract-plugin
module.exports = {"error":"Summary-module__error--S4Ain","heading":"Summary-module__heading--3vqsw","headingText":"Summary-module__headingText--Lvr9Z","errorDiv":"Summary-module__errorDiv--3Vn2E"};